module.exports = __webpack_public_path__ + "static/media/icon_journal.0a804e64.svg";